import { render, staticRenderFns } from "./RoundButtonIcon.vue?vue&type=template&id=018d31e9&"
import script from "./RoundButtonIcon.vue?vue&type=script&lang=js&"
export * from "./RoundButtonIcon.vue?vue&type=script&lang=js&"
import style0 from "./RoundButtonIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports